export function getPinnedConversationIds(workspaceId: string): Set<string> {
  try {
    const saved = localStorage.getItem(`pinned-conversations-${workspaceId}`);
    return new Set(saved ? JSON.parse(saved) : []);
  } catch {
    return new Set();
  }
}

export function savePinnedConversationIds(workspaceId: string, ids: Set<string>): void {
  try {
    localStorage.setItem(
      `pinned-conversations-${workspaceId}`,
      JSON.stringify(Array.from(ids)),
    );
  } catch {
    // ignore
  }
}

export function togglePinnedConversationId(
  workspaceId: string,
  conversationId: string,
  current?: Set<string>,
): Set<string> {
  const next = new Set(current ?? getPinnedConversationIds(workspaceId));
  if (next.has(conversationId)) {
    next.delete(conversationId);
  } else {
    next.add(conversationId);
  }
  savePinnedConversationIds(workspaceId, next);
  return next;
}

export function bulkSetPinnedConversations(
  workspaceId: string,
  conversationIds: string[],
  pin: boolean,
  current?: Set<string>,
): Set<string> {
  const next = new Set(current ?? getPinnedConversationIds(workspaceId));
  for (const id of conversationIds) {
    if (pin) {
      next.add(id);
    } else {
      next.delete(id);
    }
  }
  savePinnedConversationIds(workspaceId, next);
  return next;
}
